import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Moon, Sun, Menu, Zap } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { useTheme } from '@/context/ThemeContext';
import SidebarContent from '@/components/SidebarContent';

const TopBar = () => {
  const { dark, toggle } = useTheme();
  const location = useLocation();

  return (
    <header
      data-testid="topbar"
      className="fixed top-0 left-0 right-0 h-14 z-40 border-b border-slate-200 dark:border-slate-800 bg-white/90 dark:bg-slate-950/90 backdrop-blur-sm"
    >
      <div className="flex items-center h-full px-4 gap-3">
        {/* Mobile menu */}
        <Sheet>
          <SheetTrigger asChild>
            <button
              data-testid="mobile-menu-button"
              className="lg:hidden p-2 rounded-md text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
              aria-label="Open navigation menu"
            >
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="w-72 p-0 bg-slate-50 dark:bg-slate-950 border-r border-slate-200 dark:border-slate-800">
            <div className="pt-10 pb-4 px-4 border-b border-slate-200 dark:border-slate-800">
              <Link to="/" className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-md bg-teal-600 flex items-center justify-center flex-shrink-0">
                  <Zap className="h-4 w-4 text-white" />
                </div>
                <span className="font-semibold text-slate-900 dark:text-white text-sm font-heading">
                  Learn Power Systems
                </span>
              </Link>
            </div>
            <SidebarContent currentPath={location.pathname} />
          </SheetContent>
        </Sheet>

        {/* Logo - shows on desktop too */}
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2 lg:hidden"
        >
          <div className="w-7 h-7 rounded-md bg-teal-600 flex items-center justify-center flex-shrink-0">
            <Zap className="h-4 w-4 text-white" />
          </div>
          <span className="font-semibold text-slate-900 dark:text-white text-sm font-heading hidden sm:block">
            Learn Power Systems
          </span>
        </Link>

        <div className="flex-1" />

        {/* Dark mode toggle */}
        <button
          data-testid="darkmode-toggle"
          onClick={toggle}
          className="p-2 rounded-md text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
          aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {dark ? <Sun className="h-4.5 w-4.5" /> : <Moon className="h-4.5 w-4.5" />}
        </button>
      </div>
    </header>
  );
};

export default TopBar;
